export default __webpack_public_path__ + "assets/images/2.f858f5.webp";